
export const HIDE_SESSION_EXPIRED_DIALOG = 'app/HIDE_SESSION_EXPIRED_DIALOG';

export const hideSessionExpiredDialog = () => ({
    type: HIDE_SESSION_EXPIRED_DIALOG,
});
